import { CONFIG } from '@hero/core';
import { z } from 'zod';
import { searchColSchema } from './search.schema';

export const paginationSchema = z.object({
  limit: z.coerce.number().min(0).max(CONFIG.pagination.maxLimit).default(CONFIG.pagination.limit),
  skip: z.coerce.number().default(CONFIG.pagination.skip),
});
export type Pagination = z.infer<typeof paginationSchema>;

export const paginationWithSearchSchema = paginationSchema.extend({
  /** the search term (Atlas Search); when set, results are filtered by this term if the api supports it. */
  search: searchColSchema,
});

export type PaginationWithSearch = z.infer<typeof paginationWithSearchSchema>;
